<template>
	<view class="shop">
		<!-- 资讯信息 -->
		<view class="shop_info">
			<view class="title">全自动化下，咖啡师是否将沦为消失的职业</view>
			<view class="user">
				<view class="user_left">
					<image src="@/static/uni.png" mode="widthFix"></image>
					<text>林之秋</text>
				</view>
				<view class="user_right">关注</view>
			</view>
			<view class="desc">
				<text>阅读量 9379</text>
				<text>2022-12-04 13:51</text>
			</view>
			<view class="shop_info">
				<StoreInformation :info="info" />
			</view>
			<view class="context">
				富文本内容
			</view>
		</view>
		<!-- 操作 -->
		<view class="shop_operate" :style="{bottom: bottom ? bottom : '0', padding: bottom ? '16rpx 32rpx 16rpx 32rpx' : '16rpx 32rpx calc(env(safe-area-inset-bottom) + 16rpx) 32rpx'}">
			<view class="shop_operate_ipt">
				<input
					type="text"
					placeholder="说点什么吧"
					placeholder-style="font-size: 24rpx; color: #999999; font-weight: 400;"
					:adjust-position="false"
					cursor-spacing="0"
					@focus="inputBindFocus"
					@blur="inputBindBlur"
				/>
			</view>
			<view class="shop_operate_list">
				<view class="shop_operate_list_item" @click="open">
					<image src="@/static/icon/ic_pinglun@2x.png" mode="widthFix"></image>
					<text>评论</text>
				</view>
				<view class="shop_operate_list_item">
					<image src="@/static/icon/ic_dianzan@2x.png" mode="widthFix"></image>
					<!-- <image src="@/static/icon/Group 1049@2x.png" mode="widthFix"></image> -->
					<text>点赞</text>
				</view>
				<view class="shop_operate_list_item">
					<image src="@/static/icon/ic_shoucang@2x.png" mode="widthFix"></image>
					<!-- <image src="@/static/icon/ic_shoucang_sel@2x.png" mode="widthFix"></image> -->
					<text>收藏</text>
				</view>
				<view class="shop_operate_list_item">
					<image src="@/static/icon/ic_fenxiang@2x(1).png" mode="widthFix"></image>
					<text>分享</text>
				</view>
			</view>
		</view>
		<!-- 评论弹框 -->
		<uni-popup ref="popup" background-color="#fff">
			<view class="shop_comment">
				<view class="comment_title">
					<text>精彩评论</text>
					<view class="comment_title_close" @click="close">
						<uni-icons type="closeempty" color="#999999" size="20"></uni-icons>
					</view>
				</view>
				<scroll-view scroll-y class="comment_list">
					<view class="comment_list_item" v-for="(item, index) in 5" :key="index" @click="openItem">
						<image src="@/static/uni.png" mode="widthFix"></image>
						<view class="comment_list_item_info">
							<text class="comment_list_item_info_name">小猪佩奇</text>
							<text class="comment_list_item_info_remak">有感而发，大家可以积极讨论</text>
							<view class="comment_list_item_info_z">
								<text>11-27</text>
								<view class="z_box">
									<image src="@/static/icon/ic_dianzan@2x.png" mode="widthFix"></image>
									<text>2</text>
								</view>
							</view>
							<view class="comment_child">
								<view class="comment_list_item">
									<image src="@/static/uni.png" mode="widthFix"></image>
									<view class="comment_list_item_info">
										<text class="comment_list_item_info_name">小猪佩奇</text>
										<text class="comment_list_item_info_remak">有感而发，大家可以积极讨论</text>
										<view class="comment_list_item_info_z">
											<text>11-27</text>
											<view class="z_box">
												<image src="@/static/icon/ic_dianzan@2x.png" mode="widthFix"></image>
												<text>2</text>
											</view>
										</view>
										<view class="comment_list_item_info_gd">
											<text>展开2条回复</text>
											<image src="@/static/icon/pinglun_ic_more@2x.png" mode="widthFix"></image>
										</view>
									</view>
								</view>
							</view>
						</view>
					</view>
				</scroll-view>
				<view class="shop_comment_input" :style="{bottom: bottom ? bottom : 'env(safe-area-inset-bottom)'}">
					<input
						type="text"
						:focus="isFocus"
						placeholder="说点什么吧"
						placeholder-style="font-size: 24rpx; font-weight: 400; color: #999999;"
						:adjust-position="false"
						cursor-spacing="0"
						@focus="inputBindFocus"
						@blur="inputBindBlur"
					/>
				</view>
				<uni-popup ref="popup1" background-color="#fff">
					<view class="shop_comment_box">
						<view class="title">你的评论：有感而发，大家可以积极讨论</view>
						<view class="item" @click="reply">回复</view>
						<view class="item red" @click="dele">删除</view>
						<view class="zw"></view>
						<view class="item" @click="close1">取消</view>
					</view>
				</uni-popup>
			</view>
		</uni-popup>
	</view>
</template>

<script>
	import StoreInformation from '@/components/StoreInformation/index.vue';
	export default {
		data() {
			return {
				info: {
					img: require('@/static/uni.png'),
					name: '42coffee',
					divide: 5,
					address: '上海市闵行区申虹路'
				},
				bottom: '',
				isFocus: false
			}
		},
		components: { StoreInformation },
		methods: {
			jump(id) {
				console.log(id)
			},
			jumpUser() {
				uni.navigateTo({
					url: '/pages/authorHomepage/index'
				});
			},
			open() {
				this.$refs.popup.open('bottom')
			},
			openItem() {
				this.$refs.popup1.open('bottom')
			},
			close() {
				this.$refs.popup.close()
			},
			close1() {
				this.$refs.popup1.close()
			},
			inputBindFocus(e) {
				this.bottom = e.detail.height + 'px'
			},
			inputBindBlur(e) {
				this.bottom = ''
				this.isFocus = false
			},
			dele() {
				this.$refs.popup1.close()
			},
			reply() {
				this.$refs.popup1.close()
				this.isFocus = true
			}
		}
	}
</script>

<style>
	page {
		background-color: #ffffff !important;
	}
</style>

<style lang="scss" scoped>
	.shop {
		width: 100%;
		padding-bottom: calc(env(safe-area-inset-bottom) + 70rpx);
		.shop_comment {
			width: 100%;
			height: 90vh;
			padding: 28rpx 32rpx;
			box-sizing: border-box;
			background-color: #ffffff;
			.comment_title {
				width: 100%;
				text-align: center;
				margin-top: 16rpx;
				text {
					font-size: 32rpx;
					font-family: PingFang SC-Semibold, PingFang SC;
					font-weight: 600;
					color: #333333;
					margin-bottom: 24rpx;
				}
				.comment_title_close {
					position: absolute;
					right: 32rpx;
					top: 48rpx;
				}
			}
			.comment_list {
				width: 100%;
				height: calc(90vh - 218rpx - env(safe-area-inset-bottom));
				margin-top: 54rpx;
				.comment_list_item {
					display: flex;
					padding-bottom: 28rpx;
					margin-bottom: 28rpx;
					box-sizing: border-box;
					border-bottom: 2rpx solid #F4F5F4;
					&:last-child {
						border: none !important;
					}
					image {
						width: 64rpx;
						height: 64rpx;
						flex-shrink: 0;
						margin-right: 16rpx;
						border-radius: 50%;
					}
					.comment_list_item_info {
						flex: 1;
						display: flex;
						flex-direction: column;
						.comment_list_item_info_name {
							font-size: 24rpx;
							font-family: PingFang SC-Regular, PingFang SC;
							font-weight: 400;
							color: #999999;
						}
						.comment_list_item_info_remak {
							font-size: 28rpx;
							font-family: PingFang SC-Medium, PingFang SC;
							font-weight: 500;
							color: #333333;
							margin: 16rpx 0 12rpx 0;
						}
						.comment_list_item_info_z {
							display: flex;
							align-items: center;
							justify-content: space-between;
							margin-bottom: 28rpx;
							text {
								font-size: 24rpx;
								font-family: PingFang SC-Regular, PingFang SC;
								font-weight: 400;
								color: #999999;
							}
							.z_box {
								display: flex;
								align-items: center;
								image {
									width: 28rpx;
									height: 28rpx;
									margin-right: 8rpx;
								}
								text {
									font-size: 24rpx;
									font-family: PingFang SC-Medium, PingFang SC;
									font-weight: 500;
									color: #999999;
								}
							}
						}
						.comment_child {
							.comment_list_item {
								display: flex;
								border: none;
								padding-bottom: 0;
								image {
									width: 64rpx;
									height: 64rpx;
									flex-shrink: 0;
									margin-right: 16rpx;
									border-radius: 50%;
								}
								.comment_list_item_info {
									flex: 1;
									display: flex;
									flex-direction: column;
									.comment_list_item_info_name {
										font-size: 24rpx;
										font-family: PingFang SC-Regular, PingFang SC;
										font-weight: 400;
										color: #999999;
									}
									.comment_list_item_info_remak {
										font-size: 28rpx;
										font-family: PingFang SC-Medium, PingFang SC;
										font-weight: 500;
										color: #333333;
										margin: 16rpx 0 12rpx 0;
									}
									.comment_list_item_info_z {
										display: flex;
										align-items: center;
										margin-bottom: 0;
										justify-content: space-between;
										text {
											font-size: 24rpx;
											font-family: PingFang SC-Regular, PingFang SC;
											font-weight: 400;
											color: #999999;
										}
										.z_box {
											display: flex;
											align-items: center;
											image {
												width: 28rpx;
												height: 28rpx;
												margin-right: 8rpx;
											}
											text {
												font-size: 24rpx;
												font-family: PingFang SC-Medium, PingFang SC;
												font-weight: 500;
												color: #999999;
											}
										}
									}
									.comment_list_item_info_gd {
										display: flex;
										align-items: center;
										margin-top: 20rpx;
										text {
											font-size: 24rpx;
											font-family: PingFang SC-Semibold, PingFang SC;
											font-weight: 600;
											color: #666666;
										}
										image {
											width: 20rpx;
											height: 12rpx;
											margin-left: 4rpx;
										}
									}
								}
							}
						}
					}
				}
			}
			.shop_comment_input {
				width: 100%;
				height: 92rpx;
				position: fixed;
				left: 0;
				background-color: #ffffff;
				border-top: 2rpx solid #F4F5F4;
				padding: 14rpx 32rpx;
				box-sizing: border-box;
				input {
					width: 100%;
					height: 100%;
					border-radius: 32rpx;
					background: #F5F4F5;
					font-size: 24rpx;
					color: black;
					font-weight: 400;
					padding: 0 26rpx;
					box-sizing: border-box;
				}
			}
			.shop_comment_box {
				width: 100%;
				.title {
					width: 100%;
					text-align: center;
					font-size: 26rpx;
					font-family: PingFang SC-Regular, PingFang SC;
					font-weight: 400;
					color: #666666;
					margin: 28rpx 0;
				}
				.red {
					color: #D20A0A;
				}
				.item {
					width: 100%;
					height: 112rpx;
					line-height: 112rpx;
					text-align: center;
					border-top: 2rpx solid #F4F5F4;
				}
				.zw {
					width: 100%;
					height: 16rpx;
					background: #F5F4F5;
				}
			}
		}
		.shop_operate {
			width: 100%;
			box-sizing: border-box;
			background-color: #FFFFFF;
			border: 2rpx solid #F4F5F4;
			position: fixed;
			left: 0;
			display: flex;
			align-items: center;
			justify-content: space-between;
			.shop_operate_ipt {
				width: 368rpx;
				height: 64rpx;
				line-height: 64rpx;
				background: #F5F4F5;
				border-radius: 32rpx;
				padding: 0 26rpx;
				box-sizing: border-box;
				input {
					width: 100%;
					height: 100%;
					font-size: 24rpx;
					color: black;
				}
			}
			.shop_operate_list {
				flex: 1;
				display: flex;
				align-items: center;
				.shop_operate_list_item {
					flex: 1;
					display: flex;
					align-items: center;
					flex-direction: column;
					image {
						width: 30rpx;
						height: 30rpx;
						margin-bottom: 8rpx;
					}
					text {
						font-size: 16rpx;
						font-family: PingFang SC-Medium, PingFang SC;
						font-weight: 500;
						color: #999999;
					}
				}
			}
		}
		.shop_info {
			padding: 32rpx;
			background-color: #ffffff;
			.title {
				font-size: 44rpx;
				font-family: PingFang SC-Semibold, PingFang SC;
				font-weight: 600;
				color: #333333;
			}
			.user {
				display: flex;
				align-items: center;
				justify-content: space-between;
				margin-top: 16rpx;
				.user_left {
					display: flex;
					align-items: center;
					image {
						flex-shrink: 0;
						width: 64rpx;
						height: 64rpx;
						border-radius: 50%;
						margin-right: 12rpx;
					}
					text {
						font-size: 32rpx;
						font-family: PingFang SC-Regular, PingFang SC;
						font-weight: 400;
						color: #333333;
					}
				}
				.user_right {
					width: 128rpx;
					height: 48rpx;
					line-height: 48rpx;
					text-align: center;
					background: linear-gradient(270deg, #D20A0A 0%, #D95A5A 100%);
					border-radius: 27rpx;
					font-size: 28rpx;
					font-family: PingFang SC-Regular, PingFang SC;
					font-weight: 400;
					color: #FFFFFF;
				}
			}
			.desc {
				margin-top: 16rpx;
				display: flex;
				align-items: center;
				justify-content: space-between;
				text {
					font-size: 24rpx;
					font-family: PingFang SC-Regular, PingFang SC;
					font-weight: 400;
					color: #999999;
				}
			}
			.shop_info {
				margin-top: 24rpx;
			}
			.context {
				margin-top: 28rpx;
			}
		}
	}
</style>